import { Uid } from "./base";

export type BoardData = Uid & {
  memberUids: Map<string, Date>; // user uid : join date
  ownerUid: string;
  createdDate: Date;
  title: string;
  description: string | null;
  isPrivate: boolean;
}

export type SerializedBoardData = Uid & {
  memberUids: Record<string, number>;
  ownerUid: string;
  createdDate: number;
  title: string;
  description: string | null;
  isPrivate: boolean;
}

export function serializeBoard(b: BoardData): SerializedBoardData {
  return {
    ...b,
    createdDate: b.createdDate.getTime(),
    memberUids: Object.fromEntries(
      Array.from(b.memberUids.entries()).map(([k, v]) => [k, v.getTime()])
    ),
    isPrivate: b.isPrivate ?? false,
  };
}

export const boardTransform = (val: any): BoardData => {
  if (!val) return { uid: '', ownerUid: '', createdDate: new Date(0), title: '', description: null, memberUids: new Map(), isPrivate: false };
  return {
    ...val,
    memberUids: val.memberUids ? new Map(Object.entries(val.memberUids).map(([k, v]: [string, any]) => [k, new Date(v)])) : new Map<string, Date>(),
    createdDate: new Date(val.createdDate),
    isPrivate: !!val.isPrivate,
  };
};

export type BoardAccessResult = {
  exists: boolean;
  title: string | null;
  isMember: boolean;
  isPrivate: boolean;
  hasInvite: boolean;
};
